import smallBirbyLookDownImg from "~/assets/announcement/small-birby-look-down.svg";
import smallBirbyLookUpImg from "~/assets/announcement/small-birby-look-up.svg";

export default function Announcement() {
  return (
    <div className="h-8 w-full overflow-hidden bg-black shadow-sm">
      <div className="container mx-auto flex h-full items-center justify-center gap-4">
        {/* Left Birby - Peeking from top */}
        <img
          src={smallBirbyLookDownImg}
          alt="Birby looking down"
          className="relative top-0 h-8 w-16 shrink-0 object-contain"
        />

        {/* Centered text content */}
        <div className="font-['Figtree'] text-xs leading-[18px] font-semibold whitespace-nowrap text-white">
          <span>Get Blidz App for discount perks and </span>
          <span className="text-[#fdf853]">$30 </span>
          <span>Cash</span>
        </div>

        {/* Right Birby - Peeking from bottom */}
        <img
          src={smallBirbyLookUpImg}
          alt="Birby looking up"
          className="relative bottom-0 h-8 w-16 shrink-0 object-contain"
        />
      </div>
    </div>
  );
}
